/**
 * 公共部分
 */
import { Base } from "@/api";
import storage from "@/utils/storage";
import { ACCESS_TOKEN } from "@/utils/mutation-types";
export default {
  namespaced: true,
  state: {
    token: storage.get(ACCESS_TOKEN),
    userInfo: {},
    userId: "",
    schoolId: "",
    schoolName: "",
    isAdmin: false,
  },
  getters: {
    getToken: state => state.token,
    getUserInfo: state => state.userInfo,
    getUserId: state => state.userId,
    getSchoolId: state => state.schoolId,
    getSchoolName: state => state.schoolName,
    getIsAdmin: state => state.isAdmin,
  },
  mutations: {
    setToken(state, data) {
      state.token = data;
    },
    setUserInfo(state, data) {
      state.userInfo = data;
    },
    setUserId(state, data) {
      state.userId = data;
    },
    setSchoolId(state, data) {
      state.schoolId = data;
    },
    setSchoolName(state, data) {
      state.schoolName = data;
    },
    setIsAdmin(state, data) {
      state.isAdmin = data;
    },
  },
  actions: {
    getUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        Base.getUserInfo({})
          .then(res => {
            if (res.code === 0 && res.user) {
              commit("setUserInfo", res.user);
              commit("setUserId", res.user.userId);
              resolve(res.user);
            } else {
              commit("setUserInfo", {});
              commit("setUserId", 0);
              resolve({});
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  },
};
